import { useState, useEffect, useRef } from 'react';

/**
 * Computes elapsed seconds from a stored clock_in timestamp.
 * Persists across logout — reads from localStorage so the timer
 * continues from the correct offset when the user returns.
 */
export function useLiveTimer(clockInISO) {
  const [elapsed, setElapsed] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!clockInISO) {
      setElapsed(0);
      clearInterval(intervalRef.current);
      return;
    }

    const tick = () => {
      const start = new Date(clockInISO).getTime();
      const now = Date.now();
      setElapsed(Math.floor((now - start) / 1000));
    };

    tick(); // immediate
    intervalRef.current = setInterval(tick, 1000);
    return () => clearInterval(intervalRef.current);
  }, [clockInISO]);

  const h = String(Math.floor(elapsed / 3600)).padStart(2, '0');
  const m = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
  const s = String(elapsed % 60).padStart(2, '0');

  return `${h}:${m}:${s}`;
}